import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useSelector,useDispatch } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import CategoryFilter, { SortingItem } from "../public/HOC/CategoryFilter";
import PaginationListHOC from "../public/HOC/PaginationListHOC";
import "./CategoryItems.scss"
let pageSize = 48
export default function Explore(props) {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const category = useSelector(state => state?.category);
    const [filterData, setfilterData] = useState(props.location.state?.filter || {})
    const [windowwidth, setwindowwidth] = useState(window?.innerWidth)
    const [viewModal, setviewModal] = useState(false)
    const [configeredData, setconfigeredData] = useState({})
    const sortval = useRef([{ "field": "itemclosetime", "direction": "asc" }])
    useEffect(() => {
        window.addEventListener('resize', (resp) => {
            setwindowwidth(window?.innerWidth)
        });
        let filter = props.location.state?.filter || {}
        if (statemaintenance?.["Explore"]) {
            filter = statemaintenance?.["Explore"]?.filtervalue || filter
            sortval.current = statemaintenance?.["Explore"]?.sort || sortval.current
        }
        setfilterData((prevState) => {
            return { ...filter }
        })
        getitems({ ...filter })
        return () => { }
    }, [props.location])


    const getitems = async (filterdata ) => {
        let filter = []
        Object.keys(filterdata).map(item => {
            if (item in filterdata && filterdata?.[item] != "") {
                switch (item) {

                    case "keyword":
                        filter.push({ field: "title", value: `%${filterdata?.["keyword"]}%`, op: "LIKE", join: "AND" });
                        break
                    case "min":
                        filter.push({ "field": "bidprice", "value": filterdata?.["min"], "op": ">=", "join": "AND" });
                        break
                    case "max":
                        filter.push({ "field": "bidprice", "value": filterdata?.["max"], "op": "<=", "join": "AND" });
                        break
                    case "startdate":
                        const startdate = moment(filterdata?.["startdate"]).startOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": startdate.format("YYYY-MM-DD HH:mm:ss"), "op": ">=", "join": "AND" });
                        break;
                    case "enddate":
                        const enddate = moment(filterdata?.["enddate"]).startOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": enddate.format('YYYY-MM-DD HH:mm:ss'), "op": "<=", "join": "AND" });
                        break;
                    case "itemtype":
                        filterdata?.["itemtype"].forEach(itemstatus => {
                            if (itemstatus !== "completed") {
                                if (itemstatus == "buynow") {
                                    filter.push({ "field": "buynowprice", "value": 0, "op": ">", "join": "AND" });
                                } else if (itemstatus == "isshippable") {
                                    filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "AND" });
                                } else if (itemstatus == "pickuponly") {
                                    filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
                                } else {
                                let itemtype = { auction: 2, directBuy: 1, onSite: 3 }
                                if(itemtype[itemstatus]) {
                                    filter.push({ "field": "itemtypeid", "value": itemtype[itemstatus], "op": "=", "join": "AND" });
                                }
                            }
                            }
                        });
                        break
                    default:
                        filter.push({ "field": item, "value": filterdata?.[item], "op": "=", "join": "AND" });
                        break
                }
            }

        })

        if (filterdata?.["itemtype"]?.includes("completed")) {
            filter.push({ "field": "itemstatus", "value": "Not Sold", "op": "=", "join": "OR" });
            filter.push({ "field": "itemstatus", "value": "Sold", "op": "=", "join": "OR" });
        } else{
            filter.push({ "field": "salestatus", "value": "Started", "op": "=", "join": "AND" });
            filter.push({ "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" });
        }

        const payload = {
            "sort": sortval.current,
            "page": { "size": pageSize },
            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl', "bidprice"],
            "filter": [
                // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
                ...filter
            ]

        };
        let pusttoStore = { ...statemaintenance }
        pusttoStore["Explore"] = {
            ... pusttoStore?.["Explore"],
            filtervalue:{...filterdata},
            sort:sortval.current

        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setconfigeredData({
            payload,
            count: 3,
            pageSize: pageSize,
            type: "Item",
            history: props?.history,
            heading:"Explore",
            apiType: 'Explore'
        })
    }


    return (
        <>
            <Helmet>
                <title>CTBids | {"Explore"}</title>
            </Helmet>
            <div className="flex-fill">
                {/* <div className="d-flex align-items-center clickable mt-3" style={{ marginLeft: '90px', fontSize: "18px" }}>
                <span className="headnavbar" onClick={() => { props?.history?.push("/") }}>Home /</span>  <span className="headnavbar" onClick={() => { }}>Category /</span> <span className="subnavbar"> {filterData?.category}</span>
            </div> */}
                {filterData?.keyword != "" && <div className="d-flex align-items-center clickable mt-3" style={{ marginLeft: '90px', fontSize: "18px" }}>
                    <div className="text-bold">Showing results for: <span className="searchkey"> {filterData?.keyword}</span></div>
                </div>}
                <div className="category-container">

                    <CategoryFilter onApply={(filter) => {
                        setfilterData(filter)
                        getitems(filter)
                    }}
                        filterData={filterData}
                        hidefilter={[]}
                        viewModal={viewModal}
                        defaultkey="-1"
                        setviewModal={() => { setviewModal(!viewModal) }}
                        defultFilter = {props.location.state?.filter || {}}
                        resetFilter={() => {
                            let pusttoStore = { ...statemaintenance }
                            delete pusttoStore["Explore"] 
                            dispatch({
                                type: 'PUSH_TO_STATE', payload: pusttoStore
                            });
                            let filter = props.location.state?.filter || {}
                            setfilterData({...filter})
                            getitems({...filter})
                        }} />
                    <div className="w-100 h-100">
                        {windowwidth > 800 ? <div className="w-20">
                            <SortingItem onApply={(sortData) => {
                                sortval.current = sortData
                                getitems(filterData)
                            }}  sortvalue={"itemclosetime___asc"}/>
                        </div> :
                            <div className="d-flex align-items-end gap-3 px-3">
                                <div className="w-50">
                                <SortingItem onApply={(sortData) => {
                                    sortval.current = sortData
                                    getitems(filterData)
                                    }} 
                                    sortvalue={"itemclosetime___asc"}/>
                                </div>
                                <div className="w-50">
                                    <Button className="w-100 border  btn-white" onClick={() => { setviewModal(!viewModal) }}>Filter Results</Button>
                                </div>
                            </div>}
                        <PaginationListHOC
                            config={configeredData}
                            emptyCont={<div className='d-flex align-items-center flex-column text-center text-secondary'>
                                 <div className='emptyhead'>{"No results found , please try with different criteria"}</div>
                                {/* <div className='emptyhead'>This amazing CTBids auction does not have any listings for  {(filterData?.categoryGroup) && `${filterData?.categoryGroup} `} {(filterData?.category) && `/${filterData?.category} `}   </div>
                                <div className='emptycont'>Browse other {filterData?.categoryGroup && `categories `} in this estate sale now! </div> */}
                            </div>}
                            showAd
                        />
                    </div>

                </div>
            </div>
        </>
    )
}